/*
 * @Describe: 
 * @Author: wangalong
 * @LastEditTime: 2022-09-23 18:15:08
 */
import wx from "weixin-js-sdk";
import { getSignPackage } from "@/api/weixin";
import { isKbApp } from "@/hooks/use-env";

export const initWechat = async () => {
    const { data } = await getSignPackage()
    wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: [
            // 用的方法都要加进来
            "updateAppMessageShareData",
            "updateTimelineShareData",
        ],
        openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
    });
}

export function wxShare(param) {
    if (isKbApp) {
        return;
    }

    initWechat()
    wx.ready(function () {
        //分享到朋友圈
        wx.updateTimelineShareData({
            title: param.title, // 分享标题
            link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: param.imgUrl, // 分享图标
            success: function () { },
        });
        //分享给朋友
        wx.updateAppMessageShareData({
            title: param.title, // 分享标题
            desc: param.desc, // 分享描述
            link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: param.imgUrl, // 分享图标
            success: function () { },
        });
    });

    wx.error((e) => {
        console.log('微信加载异常', e)
    })
}